import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CarouselViewport,
} from "@loot-os/ui/components/carousel";
import { Skeleton } from "@loot-os/ui/components/skeleton";

import { ErrorBanner } from "../../../components/ErrorBanner.js";
import type { FeaturedBoxesContent } from "../../pages/home/content/featuredBoxes.js";
import { ClassicBoxTile } from "../ClassicBoxTile.js";
import { ClassicSection } from "../ClassicSection.js";

const SKELETON_KEYS = ["a", "b", "c", "d"];

/** The design's "Featured Packs" row: a carousel whose arrows appear once it overflows. */
export function ClassicFeaturedBoxes({
  title,
  currency,
  tiles,
  errorMessage,
  hidden,
}: FeaturedBoxesContent) {
  if (hidden) return null;

  return (
    <ClassicSection title={title}>
      {errorMessage && <ErrorBanner>{errorMessage}</ErrorBanner>}

      {/* A failure with nothing to show renders the banner alone: no skeleton that never
          resolves, and no empty row between two dead arrows. */}
      {tiles?.length ? (
        <Carousel>
          <CarouselViewport>
            <CarouselPrevious className="hidden sm:flex" />
            <CarouselContent>
              {tiles.map((tile) => (
                <CarouselItem
                  key={tile.box.id}
                  className="w-[calc(50%-0.5rem)] sm:w-64 lg:w-[19.25rem]"
                >
                  <ClassicBoxTile tile={tile} currency={currency} />
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselNext className="hidden sm:flex" />
          </CarouselViewport>
        </Carousel>
      ) : (
        !errorMessage && (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {SKELETON_KEYS.map((id) => (
              <Skeleton key={id} className="aspect-4/5 rounded-xl" />
            ))}
          </div>
        )
      )}
    </ClassicSection>
  );
}
